<div class="breadcrumb">
    <div class="breadcrumb-item" v-for="(matched, idx) in this.$route.matched" :key="idx">
        <span>
            <RouterLink :to="{ name: 'TopPage' }"><IconHome v-if="!matched.path"></IconHome></RouterLink>
        </span>
        <span v-if="matched.path" :class="{ 'breadcrumb-active': this.$route.path === matched.path }"><RouterLink :to="this.$route.path">{{ matched.meta.title }}</RouterLink></span>
    </div>
</div>
